import axios from 'axios';
import Cookies from 'js-cookie';

const DEFAULT_NETWORK_MESSAGE = "The request could not be processed. Refresh this page or try again momentarily.";

export let api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(config => {
  const token = Cookies.get('pl__api_access_token');
  
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  else {
    config.headers.delete('Authorization');
  }

  return config;
});

export function setAccessTokens(accessToken, refreshToken, expires = 365) {
  Cookies.set('pl__api_access_token', accessToken, { expires });
  Cookies.set('pl__api_refresh_token', refreshToken, { expires });
}

export function updateAccessTokenExpiry(expires = 365) {
  setAccessTokens(Cookies.get('pl__api_access_token'), Cookies.get('pl__api_refresh_token'), expires);
}

export function deleteAccessTokens() {
  Cookies.remove('pl__api_access_token');
  Cookies.remove('pl__api_refresh_token');
}

export function setApiLanguage(lang) {
  api.defaults.headers.common['Accept-Language'] = lang;
}

export function authorizationHeader() {
  return {
    headers: {
      Authorization: `Bearer ${Cookies.get('pl__api_access_token')}`
    }
  }
}

export const handleNetworkError = ({ e, setErrors, setValidated, message = DEFAULT_NETWORK_MESSAGE }) => {
  // Server down:
  const status = e?.response?.status;
  const data = e?.response?.data;

  let networkErrors;

  if (e?.code === 'ERR_NETWORK' || status === 500) {
    networkErrors = { non_field_errors: [ message ] };
    setValidated?.(false); // do not show the ✔️ checks on form as valid
  }
  // if it's an object, errors are set by Django:
  else if (typeof data === 'object' && !Array.isArray(data) && data !== null) {
    networkErrors = data;
    setValidated?.(true);
  }
  // another type of error (IE: 404, etc) which return a string or HTML reply:
  else {
    networkErrors = { non_field_errors: [ message ] };
    setValidated?.(false); // do not show the ✔️ checks on form as valid
  }

  setErrors?.(networkErrors);

  return { networkErrors };
}

export const apiCategorySocket = categoryId => {
  return new WebSocket(`${process.env.REACT_APP_API_WS_URL}/ws/category/?category_id=${categoryId}&token=${Cookies.get('pl__api_access_token')}`);
}